/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-02-02 18:01:31
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-22 22:21:34
 * @FilePath: /unifyxp-v2-store-portal/src/layout/EditorPageLayout/EditorCollapsePageLayout/index.tsx
 */
import React, { ReactNode } from 'react';
import css from './css.less';
//import Element from './Element/Elements';

import Listener from 'src/constrains/SizeFittingListener';

import SectionContent from '../SectionContent';
import SectionTitle from '../SectionTitle';
export { SectionContent, SectionTitle };
interface IProps {
  elements?;
  topRight?: ReactNode;
  topLeft?: ReactNode;
  avoidSizing?: boolean;
  elementInJsx?: boolean;
  children?;
}
const id = 'layouts-editorPage-editorPageCollapseContentContainer';

const Layout = (props: IProps) => {
  const { elements = [], topRight, topLeft, elementInJsx, children } = props;

  const Ele = React.useMemo(() => {
    return !elementInJsx
      ? elements.map((i, index) => {
          const { id, p = {} } = i;

          return <i.element key={id || index} {...p} />;
        })
      : elements.map((i, index) => {
          const { id, Element } = i;
          return <React.Fragment key={id}>{Element}</React.Fragment>;
        });
  }, [elements]);

  return (
    <div className={css.container}>
      <Listener id={id} />
      {(topLeft || topRight) && (
        <div className={css.topStickContainer}>
          <div className={css.topStickLeft}>{topLeft}</div>
          <div className={css.topStickRight}>{topRight}</div>
        </div>
      )}

      <div className={css.contentContainer}>
        <div className={css.contentLeft} id={id}>
          {Ele}
          {children}
        </div>
      </div>
    </div>
  );
};
export default Layout;
